import Vue from "vue"
import VueRouter from "vue-router"
import LoginView from "./Js/Pages/Login.vue"
import ForgotPasswordView from "./Js/Pages/ForgotPassword.vue"
import ProjectsView from "./Js/Pages/Projects.vue"
import AccountSettings from "./Js/Pages/AccountSettings.vue"
import AccountPassword from "./Js/Pages/AccountPassword.vue"
import ProgramsView from "./Js/Pages/Programs.vue"
import StudiesView from "./Js/Pages/Studies.vue"
import EditorView from "./Js/Pages/Editor.vue"
import DataView from "./Js/Pages/DataView.vue"
import AdminMemberEdit from "./Js/Pages/AdminMemberEdit.vue"
import AdminMemberList from "./Js/Pages/AdminMemberList.vue"
import AdminSettingsList from "./Js/Pages/AdminSettingsList.vue"


Vue.use(VueRouter);

const routes = [
    {
        path: "/login",
        component: LoginView,
        name: "login",
        meta:{
            title: "Login"
        }
    },{
        path: "/forgot-password",
        component: ForgotPasswordView,
        name: "forgot-password",
        meta:{
            title: "Reset password"
        }
    },{
        path: "/projects/active",
        component: ProjectsView,
        name: "projectsActive",
        meta:{
            title: "Active projects"
        }
    },{
        path: "/projects/archived",
        component: ProjectsView,
        name: "projectsArchived",
        meta:{
            title: "Archived projects"
        }
    },{
        path: "/project/:id/active",
        component: ProgramsView,
        name: "programsActive"
    },{
        path: "/project/:id/archived",
        component: ProgramsView,
        name: "programsArchived",
        meta:{
            title: "Archived programs"
        }
    },{
        path: "/program/:id/active",
        component: StudiesView,
        name: "studiesActive"
    },{
        path: "/program/:id/archived",
        component: StudiesView,
        name: "studiesArchived",
        meta:{
            title: "Archived studies"
        }
    },{
        path: "/aggregation/:id",
        component: EditorView,
        name: "studyAggregator",
        meta:{
            title: "Study aggregator"
        },
        children: [
            {
                path: ":section/:level",
                component: EditorView,
                name: "studyAggregatorLevel",
                children: [
                    {
                        path: ":versionId",
                        component: EditorView,
                        name: "studyAggregatorVersion"
                    }
                ]
            }
        ]
    },{
        path: "/study/:id",
        component: EditorView,
        name: "studyEditor",
        children: [
            {
                path: ":section/:level",
                component: EditorView,
                name: "studyEditorLevel",
                children: [
                    {
                        path: ":versionId",
                        component: EditorView,
                        name: "studyEditorVersion"
                    }
                ]
            }
        ]
    },{
        path: "/account",
        component: AccountSettings,
        name: "accountSettings",
        meta:{
            title: "Account settings"
        }
    },{
        path: "/member/list",
        component: AdminMemberList,
        name: "member/list",
        meta:{
            title: "Users"
        }
    }
    ,{
        path: "/settings/list",
        component: AdminSettingsList,
        name: "settings/list",
        meta:{
            title: "Settings"
        }
    }
    ,
    {
        path: "/member/create",
        component: AdminMemberEdit,
        name: "member/create",
        meta:{
            title: "Create new user"
        }
    },
    {
        path: "/member/edit/:id",
        component: AdminMemberEdit,
        name: "member/edit",
        meta:{
            title: "Edit user"
        }
    },    
    {
        path: "/account/password",
        component: AccountPassword,
        name: "accountPassword",
        meta:{
            title: "Change password"
        }
    },{
        path: "/view/:id/:section",
        component: DataView,
        name: "dataView"
    },
    {
        path: "/:page+",
        component: LoginView,
        name: "DefaultPage"
    }
];


const router = new VueRouter({
    routes,
    mode: "history"
});

router.beforeEach((to, from, next) => {
    if(to.meta.title)
        document.title = to.meta.title + " - simply.";
    else
        document.title = "simply. by SPLY";

    next()
});


export default router